<template>
  <v-dialog :width="modalWidth" :value="value" @input="$emit('input', $event)">
    <v-card>
      <v-container>
        <v-row class="pa-4 pa-sm-8">
          <v-col
            class="d-flex flex-sm-column-reverse justify-space-between align-stretch order-sm-1 pt-sm-0 pr-sm-0"
            cols="12"
            sm="6"
          >
            <ConfettiBag class="align-self-sm-start" :width="graphicWidth" />
            <v-btn
              class="align-self-start align-self-sm-end"
              icon
              @click="close"
            >
              <v-icon color="textColor">{{ closeIcon }}</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <Header :text="event.title" :level="5" />
            <Subtitle text="Deine Teilnahme" />
            <TextBody
              style="margin-bottom: 16px"
              text="Wähle die Anzahl der Gäste mit denen du teilnehmen möchtest."
            />
            <GuestAmountSelection v-model="guests" />
            <ErrorText v-if="error" text="Es ist ein Fehler aufgetreten." />
            <v-btn :loading="loading" color="primary" @click="onSubmit">
              Teilnehmen
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue"
import ConfettiBag from "components/graphics/ConfettiBag.vue"
import { mdiClose } from "@mdi/js"
import Subtitle from "components/UI/Subtitle.vue"
import TextBody from "components/UI/TextBody.vue"
import Header from "components/UI/Header.vue"
import GuestAmountSelection from "components/Event/GuestAmountSelection.vue"
import { Event } from "suus-api"
import ErrorText from "app/ui-primitives/text/ErrorText.vue"

export default defineComponent({
  name: "AttendWithGuestsDialog",
  components: {
    ErrorText,
    GuestAmountSelection,
    TextBody,
    Subtitle,
    ConfettiBag,
    Header,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object as PropType<Event>,
      required: true,
    },
  },
  computed: {
    graphicWidth(): string {
      return this.$vuetify.breakpoint.name == "xs" ? "100" : "250"
    },
    modalWidth() {
      // TODO: Refactor into mixin, also used in AttendCard
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 600
        case "sm":
          return 800
        case "md":
          return 600
        default:
          return 800
      }
    },
  },
  setup(props, { emit }) {
    const loading = ref(false)
    const error = ref(false)

    const close = () => emit("input", false)

    const guests = ref(0)
    const onSubmit = async () => {
      loading.value = true
      error.value = false
      emit("guestsSelected", guests.value)
    }

    return { close, closeIcon: mdiClose, guests, onSubmit, error, loading }
  },
})
</script>
